import { useUserStore } from '../store/user'

export default defineNuxtRouteMiddleware(() => {
  const user = useUserStore()
  if (user.isClient) {
    return navigateTo('/login')
  }
})
